module.exports = __webpack_public_path__ + "static/img/today-pick.42029eb.png";